import { ApiKeyId, ApiKeyResponse } from '@business/entities/apikey';
import { Endpoint } from '../endpoint';

export function fetchApiKeys() {
  return Endpoint.get<ApiKeyResponse[]>(`@gc/apikey`);
}

export function createApiKey() {
  return Endpoint.post<ApiKeyResponse>(`@gc/apikey`);
}

export function toggle(id: ApiKeyId) {
  return Endpoint.patch<ApiKeyResponse>(`@gc/apikey/toggle/${id}`);
}

export function deleteApiKey(id: ApiKeyId) {
  return Endpoint.delete<void>(`@gc/apikey/${id}`);
}
